/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { APPLICATION_VIEW_OFFICE } from '@gh/builder-shared-data';
import { createRoute } from '@gh/common-shared';
import { UserListTabComponent } from '../user-details/components/user-list-tab/user-list-tab.component';
import { UserListBusinessService } from '../user-details/resources/user-list-business.service';
import { ManagerTabContainerComponent } from './components/manager-tab-container/manager-tab-container.component';
import { OfficeRoleListTabComponent } from './components/office-role-list-tab/office-role-list-tab.component';
import { OfficeRolePermissionsGeneralTabComponent } from './components/office-role-permissions-application-tab/office-role-permissions-general-tab.component';
import { OfficeRolePermissionsSetupTabComponent } from './components/office-role-permissions-application-tab/office-role-permissions-setup-tab.component';
import { OfficeRoleTodoPermissionTabComponent } from './components/office-role-permissions-application-tab/office-role-todo-permission-tab/office-role-todo-permission-tab.component';
import { OfficeRolePermissionsTabContainerComponent } from './components/office-role-permissions-tab-container/office-role-permissions-tab-container.component';
import { OfficeRoleListBusinessService } from './resources/office-role-list-business.service';
import { OfficeRolePermissionsBusinessService } from './resources/office-role-permissions-business.service';

const routes = [
  createRoute({
    component: ManagerTabContainerComponent,
    path: '',
    children: [
      createRoute({
        component: OfficeRoleListTabComponent,
        path: 'office-roles',
        init: OfficeRoleListBusinessService,
        auth: {
          applicationView: APPLICATION_VIEW_OFFICE,
          permission: 'Setup.Manager.Roles.LIST',
        },
      }),
      createRoute({
        component: UserListTabComponent,
        path: 'users',
        init: UserListBusinessService,
        auth: {
          applicationView: APPLICATION_VIEW_OFFICE,
          permission: 'Setup.Manager.UserDetails.LIST',
        },
      })],
  }),
  createRoute({
    component: OfficeRolePermissionsTabContainerComponent,
    path: 'office-roles/:officeRoleId/permissions',
    init: OfficeRolePermissionsBusinessService,
    auth: {
      applicationView: APPLICATION_VIEW_OFFICE,
      permission: [
        'Setup.Manager.Roles.Permissions.EDIT',
        'Setup.Manager.Roles.Permissions.VIEW',
      ],
    },
    children: [
      createRoute({
        component: OfficeRolePermissionsGeneralTabComponent,
        path: 'general',
        init: {
          service: OfficeRolePermissionsBusinessService,
          selector: 'initGeneralTabView',
        },
        leave: true,
      }),
      createRoute({
        component: OfficeRolePermissionsSetupTabComponent,
        path: 'setup',
        init: {
          service: OfficeRolePermissionsBusinessService,
          selector: 'initSetupTabView',
        },
        leave: true,
      }),
      createRoute({
        component: OfficeRoleTodoPermissionTabComponent,
        path: 'todo',
        init: {
          service: OfficeRolePermissionsBusinessService,
          selector: 'initTodoTabView',
        },
        leave: true,
      })],
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BuilderSetupManagerRoutingModule {
}
